var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2558 11.6163C38.037 8.94455 41.963 8.94454 43.7442 11.6163L78.3359 63.5038C80.3296 66.4943 78.1858 70.5 74.5917 70.5H5.40833C1.8142 70.5 -0.329564 66.4943 1.6641 63.5038L36.2558 11.6163Z",
    fill: "#FA516F",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 24,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 43.4004 28)",
    fill: "#FA516F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.4,
    height: 6.4,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 43.4004 56)",
    fill: "#FA516F"
  })));
};
export { SvgWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM2LjI1NTggMTEuNjE2M0MzOC4wMzcgOC45NDQ1NSA0MS45NjMgOC45NDQ1NCA0My43NDQyIDExLjYxNjNMNzguMzM1OSA2My41MDM4QzgwLjMyOTYgNjYuNDk0MyA3OC4xODU4IDcwLjUgNzQuNTkxNyA3MC41SDUuNDA4MzNDMS44MTQyIDcwLjUgLTAuMzI5NTY0IDY2LjQ5NDMgMS42NjQxIDYzLjUwMzhMMzYuMjU1OCAxMS42MTYzWiIgZmlsbD0iI0ZBNTE2RiIgZmlsbC1vcGFjaXR5PSIwLjIiLz4KPHJlY3Qgd2lkdGg9IjYuNCIgaGVpZ2h0PSIyNCIgdHJhbnNmb3JtPSJtYXRyaXgoLTEgLTguNzQyMjhlLTA4IC04Ljc0MjI4ZS0wOCAxIDQzLjQwMDQgMjgpIiBmaWxsPSIjRkE1MTZGIi8+CjxyZWN0IHdpZHRoPSI2LjQiIGhlaWdodD0iNi40IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAtOC43NDIyOGUtMDggLTguNzQyMjhlLTA4IDEgNDMuNDAwNCA1NikiIGZpbGw9IiNGQTUxNkYiLz4KPC9zdmc+Cg==";